// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-details-column{border-top-left-radius:20px;border-top-right-radius:20px;background:#fff;display:flex;flex-direction:column;padding:clamp(18px,2.7778vw,40px);width:44%}@media(max-width:899px){.product-details-column{width:100%;padding:0 18px 18px}.product-details-column .back-btn-holder{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
